import React, { useState } from "react";
import { IoCallOutline, IoCall } from "react-icons/io5";
import { LuMail } from "react-icons/lu";
import { FaLocationDot } from "react-icons/fa6";

const IoCallOutlineIcon = IoCallOutline as React.ElementType;
const LuMailIcon = LuMail as React.ElementType;
const IoCallIcon = IoCall as React.ElementType;
const FaLocationDotIcon = FaLocationDot as React.ElementType;

const contactBlocks = [
  {
    icon: <LuMailIcon />,
    label: "General Queries:",
    value: "hello@nisatravels.com",
  },
  {
    icon: <LuMailIcon />,
    label: "Recruitment & Jobs:",
    value: "jobs@nisatravels.com",
  },
  {
    icon: <LuMailIcon />,
    label: "Visa & Emigration:",
    value: "services@nisatravels.com",
  },
  {
    icon: <LuMailIcon />,
    label: "Attestation & Logisticisation:",
    value: "services@nisatravels.com",
  },
  {
    icon: <LuMailIcon />,
    label: "Business Queries:",
    value: "biz@nisatravels.com",
  },
  {
    icon: <IoCallOutlineIcon />,
    label: "Helpline (Kochi):",
    value: "9188650002",
  },
  {
    icon: <IoCallOutlineIcon />,
    label: "Helpline (Head Office):",
    value: "9958070464",
  },
  { icon: <IoCallOutlineIcon />, label: "Toll Free", value: "-" },
];

const branchesIndia = [
  {
    city: "New Delhi",
    address:
      "Room No. 317, TT South Ex Plaza II, Leelaram Market, South Ex Part II, New Delhi - 110049, INDIA.",
    icons: [<FaLocationDotIcon />, <IoCallIcon />],
  },
  {
    city: "Mumbai",
    address:
      "Office No. 90, 2nd Floor, Empire Building, Dr. D.N. Road, Fort, Mumbai, Maharashtra-400001.",
    icons: [<FaLocationDotIcon />, <IoCallIcon />],
  },
  {
    city: "Kochi",
    address:
      "Nisa Tower, C P Ummer Rd. near Ambedkar Stadium, Ernakulam South, Kochi, Ernakulam, Kerala 682035",
    icons: [<FaLocationDotIcon />, <IoCallIcon />],
  },
];

const ContactPage: React.FC = () => {
  const [tab, setTab] = useState("India");

  return (
    <>
      <div className="bg-white font-manrope max-w-7xl mx-auto px-4 md:px-12 lg:px-8 md:py-10 py-5">
        <div className="flex lg:flex-row flex-col xl:gap-8 lg:gap-1 md:gap-8">
          {/* Contact Form */}
          <div className="lg:w-1/2">
            <p className="mb-4 text-[#666666] text-base leading-relaxed">
              Let’s start planning your next adventure.
            </p>
            <h2 className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-8">
              <span className="text-[#C40808]">We’re just a</span>
              <span className="text-[#0E313A] block">message away</span>
            </h2>
            <form className="grid gap-8 mt-4">
              <div className=" w-[90%] grid md:grid-cols-2 grid-cols-1 md:gap-8 gap-4">
                <div className="flex flex-col gap-2">
                  <label className="text-[#002661]">First Name*</label>
                  <input
                    className="placeholder:text-[#002661] md:border-2 border border-[#002661] w-full px-3 md:py-3 py-2"
                    placeholder="First Name"
                    required
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-[#002661]">Email Address*</label>
                  <input
                    className="placeholder:text-[#002661] md:border-2 border border-[#002661] w-full px-3 py-3"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-[#002661]">Phone*</label>
                  <input
                    className="placeholder:text-[#002661] md:border-2 border border-[#002661] w-full px-3 py-3"
                    placeholder="Phone"
                    required
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-[#002661]">Message</label>
                  <input
                    className="placeholder:text-[#002661] md:border-2 border border-[#002661] w-full px-3 py-3"
                    placeholder="Type Your Message"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="bg-[#C40808] w-[30%] text-white font-bold px-5 py-2 mt-3"
              >
                SUBMIT
              </button>
            </form>
          </div>
          {/* Contact Info */}
          <div className="mt-3 md:mt-0 xl:border-l-[3px] xl:pl-10 border-gray-200">
            <h2 className=" md:text-3xl text-2xl font-extrabold md:mb-8 mb-4">
              <span className="text-[#C40808]">We’re here to help</span>
              <span className="text-[#0E313A] block">get in touch!</span>
            </h2>
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-3 gap-2 text-sm">
              {contactBlocks.map((item, idx) => (
                <div
                  key={idx}
                  className="flex md:gap-2 gap-3 items-center py-3 text-[#002661]"
                >
                  <div className="md:w-14 w-11 md:h-14 h-11 p-2 flex items-center justify-center rounded-full border-[#002661] border-2">
                    <span className="text-[22px]">{item.icon}</span>
                  </div>

                  {/* <div className="flex flex-col md:gap-2 gap-1">
                    <span className="font-bold md:text-[18px] text-[16px]">
                      {item.label}
                    </span>
                    {item.value && (
                      <span className="font-medium md:text-[16px] text-[14px] truncate">
                        {item.value}
                      </span>
                    )}
                  </div> */}
                 <div className="flex flex-col md:gap-2 gap-1">
  <span className="font-bold md:text-[18px] text-[16px]">
    {item.label}
  </span>
  
  {item.value && (
    <span className="font-medium md:text-[16px] text-[14px] truncate">
      {/* Check if it's an Email (contains @) */}
      {item.value.includes("@") ? (
        <a href={`mailto:${item.value}`} className="hover:text-[#C40808] hover:underline transition-colors">
          {item.value}
        </a>
      ) : (
        /* Otherwise treat as Phone number */
        <a href={`tel:${item.value.replace(/\s+/g, '')}`} className="hover:text-[#C40808] hover:underline transition-colors">
          {item.value}
        </a>
      )}
    </span>
  ) }
</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#EAF0F6]">
        <div className=" font-manrope max-w-7xl mx-auto md:py-16 py-10 px-4 md:px-12 lg:px-8">
          <div className="max-w-lg mx-auto">
            <h2 className="text-center lg:text-5xl md:text-4xl text-3xl text-[#002661] font-extrabold pb-2">
              Our Branches
            </h2>
            <p className="font-inter text-center text-[#002661] pb-4 opacity-[60%]">
              Contact us today for expert advice, and unbeatable deals your
              career starts here!
            </p>
          </div>
          <div className="flex justify-center">
            <div className="flex justify-center gap-3 rounded-full p-1 bg-white border border-[#d2d5db] w-fit mb-7">
              <button
                className={`font-bold px-6 md:py-2 py-1 lg:w-[250px] md:w-[200px]  rounded-full ${
                  tab === "India"
                    ? "bg-[#C40808] text-white"
                    : " text-[#0E313A]"
                }`}
                onClick={() => setTab("India")}
              >
                India
              </button>
              <button
                className={`font-bold px-6 md:py-2 py-1 lg:w-[250px] md:w-[200px] rounded-full ${
                  tab === "International"
                    ? "bg-[#c40808] text-white"
                    : "bg-white text-[#0E313A]"
                }`}
                onClick={() => setTab("International")}
              >
                International
              </button>
            </div>
          </div>
          {tab === "India" && (
            <div className="grid md:grid-cols-3 lg:gap-10 md:gap-4 gap-10 pt-3">
              {branchesIndia.map((branch, idx) => (
                <div key={idx} className="w-[80%]">
                  <div className="w-10 h-1 bg-[#002661]" />
                  <div className="font-bold text-[#002661] text-xl mb-1 mt-3">
                    {branch.city}
                  </div>
                  <div className="text-[#002661] font-semibold opacity-[80%] text-sm mb-4">
                    {branch.address}
                  </div>
                  <div className="flex gap-2">
                    {branch.icons.map((icon, iIdx) => (
                      <div
                        key={iIdx}
                        className="flex justify-center items-center w-8 h-8 text-[#002661] md:border-2 border border-[#002661]"
                      >
                        {icon}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* Add similar grid for International if needed */}
        </div>
      </div>
    </>
  );
};

export default ContactPage;
